const ucMenus = [
  {
    icon: "list",
    key: "uc.history",
    name: "Call History",
    description: "Call History",
    url: "home/app/uc/cdr",
    productionReady: true,
  },
  {
    icon: "phone_missed",
    key: "uc.missed-calls",
    name: "Missed calls",
    description: "Missed incoming calls",
    url: "home/app/uc/missed-calls",
    productionReady: true,
  },
  {
    icon: "voicemail",
    key: "uc.voicemails",
    name: "Voicemail",
    description: "Voice mails",
    url: "home/app/uce/voicemails",
    disabled: true,
    productionReady: true,
  },
  {
    icon: "phone_callback",
    key: "uc.call-back",
    name: "Call Back",
    description: "Callbacks set for you by different users",
    url: "home/app/uc/callback",
    productionReady: true,
  },
  {
    key: "d1",
    type: "divider",
  },
  {
    icon: "contacts",
    key: "uc.contacts",
    name: "Contacts",
    description: "Phone Book",
    url: "home/app/uc/contacts",
    productionReady: true,
  },
  {
    icon: "contact_phone",
    key: "uc.personal.phoneBook",
    name: "Personal Contacts",
    description: "Personal Contacts",
    url: "home/app/personalPhonBook",
    productionReady: true,
  },
  {
    key: "d2",
    type: "divider",
  },
  {
    icon: "message",
    key: "uc.messages",
    name: "Messages",
    description: "Messages sent / received",
    url: "home/app/uc/messages",
    productionReady: true,
  },

  {
    icon: "message",
    key: "uc.broadcasts.message",
    name: " Broadcasts Message",
    description: "Broadcasts Message",
    url: "home/app/broadcastsMessage",
    productionReady: true,
  },
  {
    key: "d3",
    type: "divider",
  },
  {
    icon: "fax",
    key: "uc.fax",
    name: "Fax",
    description: "Fax",
    url: "home/app/uc/Fax",
    productionReady: true,
  },
  {
    icon: "fax",
    key: "uc.sendFax.details",
    name: "Sent-Fax-Status",
    description: "Sent-Fax-Status",
    url: "home/app/Sent-Fax-Status",
    productionReady: true,
  },
  {
    key: "d4",
    type: "divider",
  },
  {
    icon: "calendar_month_icon",
    key: "uc.conference.calendar",
    name: "Conference Calendar",
    description: "",
    url: "home/app/uc/ConferenceCalendar",
    productionReady: true,
  },
  {
    icon: "settings",
    key: "uc.conference.setting",
    name: "Conference Setting",
    description: "",
    url: "home/app/uc/ConferenceSetting",
    productionReady: true,
  },
  {
    icon: "music_video",
    key: "uc.conference.recording",
    name: "Conference Recording",
    description: "",
    url: "home/app/uc/ConferenceRecording",
    productionReady: true,
  },
  // {
  //   icon: "campaign_icon",
  //   name: "Conference Announcement",
  //   key: "distorsion",
  //   url: "/app/conference-Announcement",
  //   description: "Conference Announcement",
  // },
  {
    key: "d4",
    type: "divider",
  },
  // {
  //   icon: "link",
  //   key: "uc.conference.portal",
  //   name: "Conference Portal",
  //   description: "conference portal",
  //   url: "home/app/uc/ConferencePortal",
  // },
  // {
  //   key: "d4",
  //   type: "divider",
  // },
  {
    icon: "account_box",
    key: "uc.settings",
    name: "User Profile",
    description: "Configuration",
    url: "home/app/uc/settings",
    productionReady: true,
  },

  {
    icon: "settings",
    key: "extension.configuration",
    name: "Extension Configuration",
    description: "",
    url: "home/app/uc/ExtensionConfiguration",
    productionReady: true,
  },
  // {
  //   icon: "message",
  //   key: "uc.conference.addParticipant",
  //   name: "Meeting Participant",
  //   url: "home/app/uc/MeetingParticipant",
  //   disabled: true,
  // },
  // {
  //   icon: "lockReset",
  //   name: "Change Password",
  //   key: "Change-password",
  //   url: "/app/ChangePassword",
  //   description: "Change Password",
  // },
];

export { ucMenus };
